import { render, staticRenderFns } from "./UpdateDepartment.vue?vue&type=template&id=3299267b&scoped=true&"
import script from "./UpdateDepartment.vue?vue&type=script&lang=ts&"
export * from "./UpdateDepartment.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateDepartment.vue?vue&type=style&index=0&id=3299267b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3299267b",
  null
  
)

export default component.exports